// 首笔主币流入 - 简体中文
export default {
  title: "首笔主币流入",
  loading: { text: "拼命加载中" },
  fields: {
    address: "地址",
    txHash: "交易hash",
    quantity: "交易数量",
    txTime: "交易时间",
  },
  copy: "复制",
  none: "--",
};
